module.exports = __webpack_public_path__ + "img/sq_header_milovat_telo.6b55ffb1.jpg";